/* ------------------------ */
/*  共通コード(名称マスタ)  */
/* ------------------------ */

// 税区分
export const GC_D0001_TAX_INCLUDED = "01"; // 内税
export const GC_D0001_TAX_EXEMPT = "03"; // 非課税
export const GC_D0001_OUT_OF_SCOPE = "04"; // 不課税
export const GC_D0001_TAX_EXCLUDED = "05"; // 外税
// 混在許可区分
export const GC_D0002_ALLOW_MIXED = "01"; // 可
export const GC_D0002_DISALLOW_MIXED = "02"; // 不可
// バイヤー区分
export const GC_D0003_NON_BUYER = "0"; // バイヤー以外
export const GC_D0003_BUYER = "1"; // バイヤー
// 原価割れチェック区分
export const GC_D0004_SKIP_CHECK = "01"; // チェックしない
export const GC_D0004_DO_CHECK = "02"; // チェックする
// 発注可否
export const GC_D0010_ORDER_ENABLED = "0"; // 可
export const GC_D0010_ORDER_DISABLED = "1"; // 不可
// 店舗区分
export const GC_D0011_RC_WITH_SALES = "01"; // RC（売上有り）
export const GC_D0011_HEADQUARTERS = "02"; // 本部
export const GC_D0011_HEADQUARTERS_DC = "03"; // 本部倉庫DC
export const GC_D0011_LOGISTICS_DC = "04"; // 物流DC
// 店舗営業区分
export const GC_D0012_EXISTING_STORE = "01"; // 既存店
export const GC_D0012_NEW_STORE = "02"; // 新店
export const GC_D0012_SPECIAL_STORE = "03"; // 特殊店
export const GC_D0012_CLOSED_STORE = "04"; // 閉鎖店
export const GC_D0012_IMPORT_DIVISION = "05"; // 輸入事業部
export const GC_D0012_NON_SALES = "06"; // 営業対象外
// 店舗業態区分
export const GC_D0013_DRUGSTORE = "01"; // ドラッグストア
export const GC_D0013_PHARMACY = "02"; // 調剤
export const GC_D0013_EC = "03"; // EC
// 自動発注区分
export const GC_D0014_NOT_TARGET = "01"; // 対象外
export const GC_D0014_ORDER_ADVICE = "02"; // 発注勧告
export const GC_D0014_AUTO_ORDER = "03"; // 自動発注
// POS機種
export const GC_D0015_UNSET = "01"; // 設定なし
export const GC_D0015_WX48 = "02"; // WX-48
export const GC_D0015_ANY_CUBE = "03"; // ANY-CUBE
// POS配信区分
export const GC_D0016_DELIVER = "01"; // 配信する
export const GC_D0016_NO_DELIVER = "02"; // 配信しない
// 店舗種別
export const GC_D0018_PHARMACY = "01"; // 薬局
export const GC_D0018_STORE_PHARMACIST = "02"; // 店舗販売業（薬剤師）
export const GC_D0018_STORE_REG_SELLER = "03"; // 店舗販売業（登録販売者）
export const GC_D0018_OTHER = "04"; // その他
export const GC_D0018_UNSET = "05"; // 設定なし
// 休日タイプ
export const GC_D0019_OTHER = "01"; // その他
export const GC_D0019_RENOVATION = "02"; // 改装
export const GC_D0019_CLOSED = "03"; // 店休
// 仕入形態区分
export const GC_D0020_BUYOUT = "01"; // 買取仕入
export const GC_D0020_CONSIGNMENT = "02"; // 委託仕入
export const GC_D0020_SALE_OR_RET = "03"; // 消化仕入
// 事業者税区分
export const GC_D0021_TAXABLE = "01"; // 課税
export const GC_D0021_EXEMPT = "02"; // 免税
// 締め対象月度区分
export const GC_D0022_PREV_MONTH = "1"; // 前月
export const GC_D0022_PREV2_MONTH = "2"; // 前々月
// 月度判定基準区分
export const GC_D0023_MONTH_START = "1"; // 月度開始日
export const GC_D0023_MONTH_END = "2"; // 月度終了日
// 名称マスタ使用区分
export const GC_D0024_CC_NOT_USED = "0"; // 使用しない
export const GC_D0024_CC_USED = "1"; // 使用する
// 取引停止区分
export const GC_D0025_ALL_ALLOWED = "01"; // 全取引可
export const GC_D0025_ALL_BLOCKED = "02"; // 全取引不可
export const GC_D0025_ORDER_ONLY = "03"; // 発注のみ可
export const GC_D0025_RETURN_ONLY = "04"; // 返品のみ可
// 仕入税端数処理単位
export const GC_D0026_PAYMENT = "0"; // 支払単位
export const GC_D0026_SLIP = "1"; // 伝票単位
export const GC_D0026_LINE_ITEM = "2"; // 明細単位
// 端数処理区分
export const GC_D0027_FLOOR = "0"; // 切捨て
export const GC_D0027_ROUND = "1"; // 四捨五入
export const GC_D0027_CEIL = "2"; // 切上げ
// 発注方法
export const GC_D0028_EDI = "01"; // EDI
export const GC_D0028_HANDWRITE = "02"; // 手書き
// 本部更新権限区分
export const GC_D0029_HQ_DISABLED = "0"; // 権限なし
export const GC_D0029_HQ_ENABLED = "1"; // 権限あり
// システム管理者権限区分
export const GC_D0030_ADMIN_DISABLED = "0"; // 権限なし
export const GC_D0030_ADMIN_ENABLED = "1"; // 権限あり
// ユーザー使用可否区分
export const GC_D0031_USER_INACTIVE = "0"; // 使用不可
export const GC_D0031_USER_ACTIVE = "1"; // 使用可
// 支払サイト
export const GC_D0032_THIS_MONTH = "01"; // 当月
export const GC_D0032_NEXT_MONTH = "02"; // 翌月
export const GC_D0032_MONTH_AFTER_NEXT = "03"; // 翌々月
export const GC_D0032_AFTER_3_MONTHS = "04"; // ３ヶ月後
export const GC_D0032_AFTER_4_MONTHS = "05"; // ４ヶ月後
export const GC_D0032_AFTER_5_MONTHS = "06"; // ５ヶ月後
export const GC_D0032_AFTER_6_MONTHS = "07"; // ６ヶ月後
// 納品経路
export const GC_D0033_DIRECT_STORE = "01"; // 店舗直納
export const GC_D0033_VIA_DC = "02"; // 物流センター納品
// 通知区分
export const GC_D0034_ORDER = "01"; // 発注
export const GC_D0034_PURCHASE_RETURN = "02"; // 仕入・返品
export const GC_D0034_STORE_TRANSFER = "03"; // 店間移動入出庫
export const GC_D0034_DISPOSAL_EXPENSE = "04"; // 廃棄・経費振替
export const GC_D0034_INVENTORY = "05"; // 棚卸
export const GC_D0034_ITEM_MASTER = "06"; // 商品マスタ
// 取引先制限
export const GC_D0035_TARGET = "01"; // 対象
export const GC_D0035_NOT_TARGET = "02"; // 対象外
// 商品荷姿
export const GC_D0036_SINGLE_ITEM = "01"; // 単品
export const GC_D0036_BALL = "02"; // ボール
export const GC_D0036_CASE = "03"; // ケース
export const GC_D0036_SET = "04"; // セット
// 伝票形式
export const GC_D0037_TYPE1 = "01"; // Ⅰ型
export const GC_D0037_TYPE2 = "02"; // Ⅱ型
export const GC_D0037_TYPE3 = "03"; // Ⅲ型
export const GC_D0037_TYPE4 = "04"; // Ⅳ型
// 棚卸商品マスタ登録方法
export const GC_D0038_CODE_SCAN = "01"; // コード読取
export const GC_D0038_MASTER_ENTRY = "02"; // マスタ入力
export const GC_D0038_STOCK_IO = "03"; // 在庫受払
// 配信ステータス(EDI)
export const GC_D0039_NOT_DELIVERED = "0"; // 未配信
export const GC_D0039_DELIVERED_RECEIVED = "1"; // 配信済（受領）
export const GC_D0039_DELIVERED_CORRECTED = "2"; // 配信済（受領訂正）
export const GC_D0039_DELIVERED_RETURNED = "3"; // 配信済（返品）
export const GC_D0039_NOT_TARGET_NON_EDI = "9"; // 配信対象外（非EDI）
// 配送区分
export const GC_D0040_STORE_DIRECT = "01"; // 店直
export const GC_D0040_TC1 = "02"; // TC1
export const GC_D0040_TC2 = "03"; // TC2
// 祝日区分
export const GC_D0041_NON_HOLIDAY = "0"; // 祝祭日以外
export const GC_D0041_HOLIDAY = "1"; // 祝祭日
// 受払区分
export const GC_D0042_PURCHASE = "01"; // 仕入
export const GC_D0042_DISCOUNT = "02"; // 値引
export const GC_D0042_RETURN = "03"; // 返品
export const GC_D0042_TRANSFER_OUT = "04"; // 店間移動出庫
export const GC_D0042_TRANSFER_IN = "05"; // 店間移動入庫
export const GC_D0042_DISPOSAL = "06"; // 廃棄
export const GC_D0042_LOSS = "07"; // ロス
export const GC_D0042_THEFT = "08"; // 盗難
export const GC_D0042_EXPENSE_TRANSFER = "09"; // 経費振替
export const GC_D0042_STOCK_ADJUST = "10"; // 在庫調
export const GC_D0042_SALES = "11"; // 売上
export const GC_D0042_INVENTORY = "12"; // 棚卸
export const GC_D0042_INVENTORY_RECLASS = "13"; // 在庫組替
// パターンタイプ区分
export const GC_D0043_COST = "01"; // 原価 
export const GC_D0043_SELLING_PRICE = "02"; // 売価
// セット商品作成元区分
export const GC_D0044_RETAIL = "1"; // 小売
export const GC_D0044_MANUFACTURER = "2"; // メーカー
// 店間移動伝票区分
export const GC_D0045_INTERSTORE = "1"; // 店間移動
export const GC_D0045_DC_INVENTORY = "2"; // DC在庫
// 伝票取消フラグ
export const GC_D0046_VALID = "0"; // 有効
export const GC_D0046_CANCELLED = "1"; // 取消
// 返品・値引理由
export const GC_D0047_UNORDERED_ITEM = "001"; // 注文外商品
export const GC_D0047_SLIP_ENTRY_ERROR = "002"; // 伝票記入ミス
export const GC_D0047_DEFECTIVE_QUALITY = "004"; // 品質不良品
export const GC_D0047_DISCOUNT = "013"; // 値引
export const GC_D0047_DELIVERY_CORRECTION = "016"; // 納品訂正
export const GC_D0047_DEFECTIVE_ITEM = "017"; // 商品不良
export const GC_D0047_DAMAGED_ITEM = "018"; // 汚破損
// 通知確認フラグ
export const GC_D0048_UNACK = "0"; // 未確認
export const GC_D0048_ACK = "1"; // 確認済
// 予約反映ステータス
export const GC_D0049_WAITING_REFLECT = "0"; // 未反映
export const GC_D0049_REFLECTED = "1"; // 反映済
export const GC_D0049_ERROR = "9"; // エラー
// エラー種別(納品)
export const GC_D0050_ERROR = "9"; // エラー
export const GC_D0050_WARNING = "2"; // ワーニング
// 過剰発注チェック区分
export const GC_D0051_SKIP_CHECK = "0"; // チェックしない
export const GC_D0051_DO_CHECK = "1"; // チェックする
// 業務区分(採番用)
export const GC_D0052_PURCHASE_ORD = "01"; // 発注
export const GC_D0052_PURCH_RET_DISC = "02"; // 仕入・返品・値引
export const GC_D0052_INTER_STR_TRN = "03"; // 店間移動入出庫
export const GC_D0052_DISP_EXP_ADJ = "04"; // 廃棄・経費振替・在庫調整
export const GC_D0052_INV_RECLASS = "05"; // 在庫組替
export const GC_D0052_SALES = "06"; // 売上
// 設定区分
export const GC_D0053_SALES_TARGET = "02"; // 売上対象区分
export const GC_D0053_CYCLE_COUNT = "03"; // 定型棚卸区分
export const GC_D0053_MGMT_COST_EVAL = "04"; // 管理会計用在庫評価方法
export const GC_D0053_FISCAL_COST_EVAL = "05"; // 財務会計用在庫評価方法
export const GC_D0053_TENANT_SETTING = "06"; // テナント設定区分
export const GC_D0053_AUTO_ORDER_SET = "07"; // 自動発注対象設定
export const GC_D0053_FRESH_TRANSFER = "08"; // 生鮮部門振替マスタ
export const GC_D0053_CLASS_MOVE_AUTO = "09"; // 分類移動伝票自動作成
export const GC_D0053_DEAD_STOCK_DAYS = "10"; // 不動在庫回転日数
// 理論在庫更新フラグ
export const GC_D0054_WAITING_REFLECT = "0"; // 未更新
export const GC_D0054_REFLECTED = "1"; // 更新済
export const GC_D0054_EXCLUDED = "2"; // 更新対象外
// メーカー親子区分
export const GC_D0055_CHILD = "01"; // 子
export const GC_D0055_PARENT = "02"; // 親
// 日次集計登録フラグ
export const GC_D0056_WAITING_REFLECT = "0"; // 未登録
export const GC_D0056_REFLECTED = "1"; // 登録済
// 売価変更区分
export const GC_D0057_NEW = "01"; // 新規
export const GC_D0057_CHANGE = "02"; // 変更
// ドメイン区分
export const GC_D0060_MASTER = "MT"; // マスタ
export const GC_D0060_COMMON = "CM"; // 共通
export const GC_D0060_ORDER = "OR"; // 発注
export const GC_D0060_PURCHASE_RETURN = "PR"; // 仕入・返品
export const GC_D0060_INVENTORY = "ST"; // 在庫
export const GC_D0060_STOCKTAKE = "IV"; // 棚卸
export const GC_D0060_OPS_SUPPORT = "BS"; // 業務支援
export const GC_D0060_SALES_POS = "SA"; // POS・売上
export const GC_D0060_LIQUOR_RPT = "AL"; // 酒類報告
export const GC_D0060_AP_PAYMENT = "AP"; // 買掛・支払い
export const GC_D0060_MGMT_AGGREGATE = "SM"; // 商管集計
// 分類階層
export const GC_D0069_MAJOR_CATEGORY = "01"; // 大分類
export const GC_D0069_MIDDLE_CATEGORY = "02"; // 中分類
export const GC_D0069_SUB_CATEGORY = "03"; // 小分類
export const GC_D0069_MINOR_CATEGORY = "04"; // 細分類
// 最下層フラグ
export const GC_D0071_NOT_BOTTOM = "01"; // 最下層ではない
export const GC_D0071_BOTTOM = "02"; // 最下層
// 管理コード
export const GC_D0072_COSMETICS_CAT = "01"; // 化粧品分類
export const GC_D0072_PRIORITY_CAT = "02"; // 重点品分類
// 指定取引先物流
export const GC_D0073_ALLOW_ALL = "01"; // 全て可
// 発注停止区分
export const GC_D0075_NORMAL = "01"; // 発注可
export const GC_D0075_STOP = "02"; // 停止
export const GC_D0075_PENDING = "03"; // 取扱検討中
// 返品区分
export const GC_D0076_RETURN_OK = "00"; // 返品可
export const GC_D0076_RETURN_NO = "01"; // 返品不可
export const GC_D0076_EXPIRY_OK = "02"; // 期限切れ可
export const GC_D0076_EXPIRY_NO = "03"; // 期限切れ不可
export const GC_D0076_EXP3_MONTHS = "04"; // 消費期限3か月
export const GC_D0076_EXP2_MONTHS = "05"; // 消費期限2か月
export const GC_D0076_EXP2TO1_MO = "06"; // 消費期限2-1か月
export const GC_D0076_PART_EXCHANGE = "07"; // 一部交換可能
export const GC_D0076_RENEWAL_OK = "08"; // ﾘﾆｭｰｱﾙ時可能
// 本部発注停止理由
export const GC_D0077_NORMAL_DATA = "00"; // 通常データ
export const GC_D0077_STOCK_ADJUST = "01"; // 在庫調整商品
export const GC_D0077_MAKER_SHORT = "02"; // メーカ欠品
export const GC_D0077_SPECIAL_ORDER = "03"; // 取寄せ商品
export const GC_D0077_LIMITED_TIME = "04"; // 期間限定
export const GC_D0077_STANDARD = "05"; // 規格品
export const GC_D0077_STORE_FAX_ITEM = "06"; // 店舗FAX発注商品
export const GC_D0077_SALE_ONLY = "07"; // 販売のみ
export const GC_D0077_AFTER_CONFIRM_FAX = "08"; // 確認後FAX
// 物流移動可否区分
export const GC_D0078_MOVE_NOT_ALLOWED = "0"; // 移動不可
export const GC_D0078_MOVE_ALLOWED = "1"; // 移動可
// 原価区分
export const D0079_BASE_COST = "01"; // 原単価
export const D0079_MARKUP_RATE = "02"; // 値入率
// 改廃理由
export const GC_D0080_NORMAL = "01"; // 通常
export const GC_D0080_SUCCESSOR = "02"; // 後継
export const GC_D0080_ALTERNATIVE = "03"; // 代替
// 自動発注区分
export const GC_D0082_NOT_TARGET = "0"; // 自動発注対象外
export const GC_D0082_AUTO_ORDER = "1"; // 自動発注対象
// 自動発注制御
export const GC_D0083_MANUAL_ORDER = "0"; // 手動発注
export const GC_D0083_AUTO_ORDER = "1"; // 自動発注
// ポイント区分
export const GC_D0085_NORMAL = "0"; // 通常
export const GC_D0085_ONE_TIMES = "1"; // １倍
export const GC_D0085_EXCLUDED = "2"; // 対象外
// 発注制限
export const GC_D0090_NORMAL = "0"; // 制限なし
export const GC_D0090_HQ_ORDER_ONLY = "1"; // 本部発注のみ可
// 経費品区分
export const GC_D0091_PRODUCT = "0"; // 商品
export const GC_D0091_SUPPLY_ITEM = "1"; // 用度品
// 自動値引禁止
export const GC_D0092_NORMAL = "0"; // 通常
export const GC_D0092_PROHIBIT = "1"; // 禁止
// 内容量単位
export const GC_D0093_UNSET = "00"; // 未設定
export const GC_D0093_KILOLITER = "01"; // kl
export const GC_D0093_LITER = "02"; // l
export const GC_D0093_DECILITER = "03"; // dl
export const GC_D0093_MILLILITER = "05"; // ml
export const GC_D0093_KILOGRAM = "06"; // kg
export const GC_D0093_GRAM = "07"; // g
export const GC_D0093_MILLIGRAM = "08"; // mg
export const GC_D0093_CC = "09"; // cc
// カラー・サイズコード
export const GC_D0094_UNSET = "0"; // 未設定
// 形状
export const GC_D0095_LINE_ITEM = "0"; // ライン商品
export const GC_D0095_NON_LINE_ITEM = "1"; // 非ライン商品
// 値付
export const GC_D0096_NOT_NEEDED = "0"; // 不要
export const GC_D0096_VENDOR_PRICING = "1"; // 取引先値付
export const GC_D0096_CENTER_PRICING = "2"; // センタ値付
export const GC_D0096_STORE_PRICING = "3"; // 店舗値付
export const GC_D0096_CUT_SALE = "4"; // 切売
export const GC_D0096_NO_LABEL = "5"; // ノンラベル
// 一般用医薬品
export const GC_D0097_NOT_APPLICABLE = "0"; // 該当なし
export const GC_D0097_GUIDANCE_OTC = "1"; // 要指導医薬品
export const GC_D0097_CLASS1_OTC = "2"; // 第1類医薬品
export const GC_D0097_CLASS2_OTC = "3"; // 第2類医薬品
export const GC_D0097_SPEC_CLASS2_OTC = "4"; // 指定第2類医薬品
export const GC_D0097_CLASS3_OTC = "5"; // 第3類医薬品
// 医薬部外品
export const GC_D0098_NOT_APPLICABLE = "0"; // 該当なし
export const GC_D0098_QUASI_DRUG = "1"; // 医薬部外品
export const GC_D0098_SPEC_QUASI = "2"; // 指定医薬部外品
export const GC_D0098_PEST_QUASI = "3"; // 防除用医薬部外品
// 毒劇薬
export const GC_D0099_NOT_APPLICABLE = "0"; // 該当なし
export const GC_D0099_POISON_DRUG = "1"; // 毒薬
export const GC_D0099_DELETERIOUS_DRUG = "2"; // 劇薬
// 毒劇物
export const GC_D0100_NOT_APPLICABLE = "0"; // 該当なし
export const GC_D0100_POISON_SUB = "1"; // 毒物
export const GC_D0100_DELETERIOUS_SUB = "2"; // 劇物
// ＬＴ区分
export const GC_D0101_NORMAL = "0"; // 通常
export const GC_D0101_FIRST_SHIP = "1"; // １便
export const GC_D0101_SECOND_SHIP = "2"; // ２便
// 抽出区分
export const GC_D0102_EXCLUDE_DELETED = "0"; // 削除商品を除く
export const GC_D0102_INCLUDE_DELETED = "1"; // 削除商品も含む
export const GC_D0102_ONLY_DELETED = "2"; // 削除商品のみ
// パスワード複雑性
export const GC_D0103_REQUIRE_COMPLEX = "1"; // 複雑なパスワードを要求
export const GC_D0103_ALLOW_SIMPLE = "2"; // 単純でも可
// 権限外データ参照
export const GC_D0104_ALLOW = "01"; // する
export const GC_D0104_DISALLOW = "02"; // しない
// 買掛作成区分
export const GC_D0105_UNSET = "0"; // 設定なし
// 使用不可理由コード
export const GC_D0106_RETIRED = "01"; // 退職
export const GC_D0106_ON_LEAVE = "02"; // 休職
export const GC_D0106_DUPLICATE = "03"; // 重複登録
export const GC_D0106_OTHER = "04"; // その他
// 活動中フラグ
export const GC_D0107_INACTIVE = "01"; // 停止中
export const GC_D0107_ACTIVE = "02"; // 活動中
// 職責コード
export const GC_D0108_NONE = "01"; // なし
export const GC_D0108_FRESH_AREA_HEAD = "02"; // 生鮮エリア統括
export const GC_D0108_CATEGORY_LEAD = "03"; // カテゴリーリーダー
export const GC_D0108_AREA_CAT_LEAD = "04"; // エリアカテゴリーリーダー
export const GC_D0108_BLOCK_HEAD = "05"; // ブロック長
export const GC_D0108_AREA_BLOCK_HEAD = "06"; // エリアブロック長
export const GC_D0108_BRANCH_ASST = "07"; // 支社長補佐
export const GC_D0108_CAT_DIRECTOR = "08"; // 部門カテゴリー・ディレクター
export const GC_D0108_BRANCH_DEPUTY = "09"; // 支社長代行
export const GC_D0108_HQ_DEPUTY = "10"; // 本部長代行
export const GC_D0108_BRANCH_MGR = "11"; // 支社長
export const GC_D0108_CHIEF_STORE_MGR = "12"; // 統括店長
export const GC_D0108_STORE_MGR = "13"; // 店長
export const GC_D0108_DEPUTY_STORE = "14"; // 副店長
export const GC_D0108_STAFF = "15"; // スタッフ
export const GC_D0108_CONCIERGE = "16"; // コンシェルジュ
export const GC_D0108_DEPT_MGR = "17"; // 部門長
export const GC_D0108_STORE_ASST = "18"; // 店長補佐
export const GC_D0108_CC = "19"; // カテゴリー・キャプテン
export const GC_D0108_CO = "20"; // カテゴリー・オーナー
export const GC_D0108_SUPER_CC = "21"; // スーパーカテゴリー・キャプテン
export const GC_D0108_SECTION_HEAD = "22"; // 部責任者
export const GC_D0108_OFFICE_HEAD = "23"; // 室責任者
export const GC_D0108_MEISTER_MGR = "24"; // マイスター店長
export const GC_D0108_AREA_CAT_ASST = "25"; // エリアカテゴリーリーダー補佐
export const GC_D0108_SECTION_MGR = "26"; // 課責任者
export const GC_D0108_SUPER_STORE_MGR = "27"; // スーパー店長
export const GC_D0108_SV = "28"; // スーパーバイザー
export const GC_D0108_STORE_ACTING = "29"; // 店長代理
export const GC_D0108_STORE_DEPUTY = "30"; // 店長代行
export const GC_D0108_GENERAL_MGR = "31"; // 支配人
export const GC_D0108_CAT_LEAD_ASST = "32"; // カテゴリーリーダー補佐
export const GC_D0108_CASH_CONCIERGE = "33"; // レジコンシェルジュ
export const GC_D0108_HQ_MGR = "34"; // 本部長
// 属性タイプ
export const GC_D0110_ORGANIZATION = "1"; // 組織関連
export const GC_D0110_PRODUCT_MASTER = "2"; // 商品マスタ
export const GC_D0110_OTHER = "3"; // その他
// 登録範囲
export const GC_D0112_STORE_LEVEL = "01"; // 店舗別
export const GC_D0112_GROUP_LEVEL = "02"; // グループ別
// 委託区分
export const GC_D0113_CONSIGNED = "01"; // 委託
export const GC_D0113_PURCHASED = "02"; // 仕入
// 指示作成状況
export const GC_D0114_NOT_CREATED = "01"; // 未作成
export const GC_D0114_CREATED = "02"; // 作成済
export const GC_D0114_DELETED = "03"; // 削除済
// 便
export const GC_D0115_FIRST_DELIVERY = "1"; // 1
export const GC_D0115_SECOND_DELIVERY = "2"; // 2
// 発注締め時間
export const GC_D0116_1200 = "1"; // 12:00
export const GC_D0116_1400 = "2"; // 14:00
// 部分棚卸
export const GC_D0117_ALLOW = "01"; // する
export const GC_D0117_DISALLOW = "02"; // しない
// 権限
export const GC_D0118_NO_ACCESS = "01"; // 使用不可
export const GC_D0118_READ_ONLY = "02"; // 閲覧のみ
export const GC_D0118_EDITABLE = "03"; // 更新可能
// POP
export const GC_D0122_UNSET = "01"; // 未設定
export const GC_D0122_CM = "02"; // cm
export const GC_D0122_M = "03"; // m
export const GC_D0122_MM = "04"; // mm
// 表示店舗条件
export const GC_D0123_ALL_STORES = "01"; // 全店舗
export const GC_D0123_NOT_PRINTED = "02"; // 未印刷のみ
export const GC_D0123_NOT_COMPLETED = "03"; // 未完了のみ
export const GC_D0123_WITH_COMMENT = "04"; // コメントありのみ
// 取込ステータス
export const GC_D0125_COMPLETED = "01"; // 正常終了
export const GC_D0125_ERROR_END = "02"; // 異常終了
// 取込形式
export const GC_D0126_FULL_REPLACE = "01"; // 総入替
export const GC_D0126_ADD_UPDATE = "02"; // 追加/更新
export const GC_D0126_DELETE = "03"; // 削除
// 管理区分
export const GC_D0128_FRESH_CAT = "01"; // 生鮮分類別
export const GC_D0128_SUB_CAT = "02"; // 小分類別
export const GC_D0128_PRODUCT_LEVEL = "03"; // 商品別
// 発注用在庫数更新
export const GC_D0129_UPDATE = "01"; // 更新する
export const GC_D0129_NO_UPDATE = "02"; // 更新しない
// 営業中棚卸
export const GC_D0130_ALLOW = "01"; // する
export const GC_D0130_DISALLOW = "02"; // しない
// 棚卸差異要調査条件区分
export const GC_D0132_DIFF_QTY = "1"; // 差異数量
export const GC_D0132_DIFF_COST_AMT = "2"; // 差異原価金額
export const GC_D0132_DIFF_PRICE_AMT = "3"; // 差異売価金額
// 例外店舗
export const GC_D0136_EXCLUDE_EX_STORE = "01"; // 例外店舗はグループ情報で更新しない
export const GC_D0136_UPDATE_ALL_GROUP = "02"; // グループに属する店舗を全て更新する
// 更新区分
export const GC_D0137_ADD_UPD_COPY = "01"; // 追加更新複写
export const GC_D0137_ADD_COPY_ONLY = "02"; // 追加複写のみ
export const GC_D0137_REPLACE = "03"; // 入替
// 集計方法
export const GC_D0138_INPUT_LEVEL = "01"; // 棚卸入力別
export const GC_D0138_PRODUCT_LEVEL = "02"; // 商品別
export const GC_D0138_MID_CAT_LEVEL = "03"; // 商品中分類別
export const GC_D0138_SUB_CAT_LEVEL = "04"; // 商品小分類別
export const GC_D0138_STORE_LEVEL = "05"; // 店舗別
// 配信頻度
export const GC_D0139_ONCE = "00"; // 1度のみ
export const GC_D0139_HOURLY = "01"; // 毎時間
export const GC_D0139_DAILY = "02"; // 毎日
export const GC_D0139_WEEKLY = "03"; // 毎週
export const GC_D0139_MONTHLY = "04"; // 毎月
export const GC_D0139_DISABLED = "05"; // 無効
// 棚卸種別
export const GC_D0140_PHYSICAL_COUNT = "01"; // 実棚
export const GC_D0140_PURCHASE_ADJ = "02"; // 仕入補正
export const GC_D0140_POS_ADJ = "03"; // POS補正
export const GC_D0140_HQ_ADJ = "04"; // 本部調整
// 棚卸状況
export const GC_D0141_BEFORE_COUNT = "01"; // 棚卸開始前
export const GC_D0141_COUNTING = "02"; // 棚卸実施中
export const GC_D0141_STORE_CONFIRMED = "03"; // 店舗確定済
export const GC_D0141_HQ_CONFIRMED = "04"; // 本部確定済
export const GC_D0141_STOCK_REFLECTED = "05"; // 在庫反映済
export const GC_D0141_COUNT_CANCELED = "06"; // 棚卸取消済
// 棚卸対象受払期間
export const GC_D0146_90DAYS = "01"; // 90
export const GC_D0146_180DAYS = "02"; // 180
export const GC_D0146_360DAYS = "03"; // 360
export const GC_D0146_720DAYS = "04"; // 720
// マイメニュー
export const GC_D0150_NORMAL_MAINT = "011"; // 通常メンテナンス
export const GC_D0150_RESERVE_MAINT = "012"; // 予約マスタメンテナンス
export const GC_D0150_PRODUCT_IMPORT = "013"; // 商品マスタ取込
export const GC_D0150_PLAN_MASTER = "014"; // 企画マスタ
export const GC_D0150_PRODUCT_ASSIST = "015"; // 商品マスタ補助
export const GC_D0150_ORDER_APPROVAL = "022"; // 発注承認
export const GC_D0150_HQ_ORDER = "023"; // 本部発注
export const GC_D0150_ORDER_RESULT = "025"; // 発注結果
export const GC_D0150_PURCHASE_MGMT = "031"; // 仕入・返品・値引
export const GC_D0150_PAYABLE_MGMT = "051"; // 買掛管理
export const GC_D0150_MASTER_MGMT = "054"; // マスタ管理
export const GC_D0150_SCHEDULE_MASTER = "061"; // スケジュールマスタ
export const GC_D0150_STOCKTAKE_MGMT = "062"; // 棚卸管理
export const GC_D0150_SALES = "081"; // 売上
export const GC_D0150_INVENTORY = "082"; // 在庫
export const GC_D0150_LIQUOR = "083"; // 酒類
export const GC_D0150_VENDOR_REL = "091"; // 取引先関連
export const GC_D0150_CATEGORY_REL = "092"; // 分類関連
export const GC_D0150_OTHERS = "093"; // その他
export const GC_D0150_USER_MASTER = "101"; // ユーザー用マスタ
export const GC_D0150_CONFIG_MASTER = "102"; // 設定マスタ
export const GC_D0150_INQUIRY = "111"; // 照会
export const GC_D0150_PORTAL = "121"; //  
// サブメニュー
export const GC_D0151_PRODUCT_MASTER = "01"; // 商品マスタ関連
export const GC_D0151_ORDERING = "02"; // 発注
export const GC_D0151_PURCHASE_RETURN = "03"; // 仕入／承認返品
export const GC_D0151_PAYABLE_NOTICE = "05"; // 買掛／支払案内
export const GC_D0151_STOCKTAKE_HQ = "06"; // 棚卸（本部業務）
export const GC_D0151_PRODUCT_MGMT = "08"; // 商品管理
export const GC_D0151_BASIC_MASTER = "09"; // 基本マスタ
export const GC_D0151_SYSTEM_MASTER = "10"; // システムマスタ
export const GC_D0151_SYS_ADMIN_MST = "11"; // システム管理マスタ
export const GC_D0151_POLTAL = "12"; //  
// 納品実績取込区分
export const GC_D0153_IMPORT_RECEIVED = "01"; // 検収済で納品実績取込
export const GC_D0153_IMPORT_UNRECEIVED = "02"; // 未検収で納品実績取込
export const GC_D0153_RECEIVE_ONLY = "03"; // 納品実績受信のみ
// 伝票状態
export const GC_D0154_NOT_INSPECTED = "0"; // 未検収
export const GC_D0154_INSPECTED = "1"; // 検収済
export const GC_D0154_NOT_INSPECTED_WARN = "2"; // 未検収(ワーニング)
// 配信状態
export const GC_D0155_PENDING_DELIVER = "01"; // 配信待
export const GC_D0155_DELIVERED = "02"; // 配信済
export const GC_D0155_NOT_DELIVER = "03"; // 配信対象外
// 発注区分
export const GC_D0157_HQ_ORDER = "01"; // 本部発注
export const GC_D0157_STORE_ORDER = "02"; // 店舗発注
// 伝票区分
export const GC_D0158_PURCHASE = "01"; // 仕入
export const GC_D0158_RETURN = "02"; // 返品
export const GC_D0158_DISCOUNT = "04"; // 値引
// インターフェイス種別
export const GC_D0200_B_LUCK = "01"; // B-Luck
export const GC_D0200_POS = "02"; // POS
export const GC_D0200_EDI = "03"; // EDI
export const GC_D0200_CORE_SYSTEM = "04"; // 基幹
// バッチ処理種別
export const GC_D0201_IN = "1"; // IN(受信)
export const GC_D0201_OUT = "2"; // OUT(送信)
export const GC_D0201_INTERNAL = "3"; // 内部
// 文字コード種別
export const GC_D0202_SHIFT_JIS = "1"; // SHIFT_JIS
export const GC_D0202_UTF8 = "2"; // UTF8
// 改行コード種別
export const GC_D0203_CRLF = "1"; // CRLF
export const GC_D0203_LF = "2"; // LF
// 拡張子種別
export const GC_D0204_TXT = "1"; // TXT
export const GC_D0204_CSV = "2"; // CSV
// 表示フラグ
export const GC_D0205_DISP_OFF = "0"; // OFF
export const GC_D0205_DISP_ON = "1"; // ON
// 言語
export const GC_D0490_CHINESE = "CHG"; // 中国語
export const GC_D0490_ENGLISH = "ENG"; // 英語
export const GC_D0490_JAPANESE = "JPN"; // 日本語
export const GC_D0490_KOREAN = "KOR"; // ハングル
export const GC_D0490_VIETNAMESE = "VNM"; // ベトナム語
// 企画区分
export const GC_D2002_MONTHLY_PROMO = "01"; // 月間特売
export const GC_D2002_COMP_PRICE = "02"; // 競合店売価
export const GC_D2002_FLYER = "03"; // チラシ
export const GC_D2002_WEEKDAY_PROMO = "04"; // 曜日プロモーション
export const GC_D2002_REBATE = "05"; // リベート
export const GC_D2002_OTHER = "99"; // その他
// POS原価使用
export const GC_D2006_DO_NOT_USE = "01"; // しない
export const GC_D2006_USE = "02"; // する
// 店舗訂正
export const GC_D2008_ALLOW = "01"; // 可
export const GC_D2008_DISALLOW = "02"; // 不可
// 販促区分
export const GC_D2009_NO_PROMO = "0"; // 適用なし
export const GC_D2009_ORDER_PROMO = "1"; // 発注適用
// 終了タイミング
export const GC_D2011_BUSINESS_DATE = "1"; // 営業日付
export const GC_D2011_CALENDAR_DATE = "2"; // カレンダー日付
// 商品コード区分
export const GC_D2012_EAN_UCC8 = "004"; // EAN(JAN)/UCC8桁
export const GC_D2012_EAN_UCC13 = "005"; // EAN(JAN)/UCC13桁
export const GC_D2012_GTIN14 = "006"; // EAN/UCC14桁(GTIN)
export const GC_D2012_ITF14 = "007"; // ITF14桁
export const GC_D2012_UPC12 = "015"; // UPC12桁
export const GC_D2012_UPC8 = "016"; // UPC8桁
export const GC_D2012_INHOUSE_CODE = "999"; // 自社ｺｰﾄﾞ
// ケースセット区分
export const GC_D2013_CASE_ITEM = "1"; // ケース商品
export const GC_D2013_SET_ITEM = "2"; // セット商品
export const GC_D2013_SERIES_ITEM = "3"; // シリーズ商品
// 属性タイプ
export const GC_D2014_SOLID = "01"; // 固体
export const GC_D2014_LIQUID = "02"; // 液体
export const GC_D2014_GAS = "03"; // 気体
// 赤黒伝票区分
export const GC_D2016_NORMAL_SLIP = "01"; // 黒伝
export const GC_D2016_CORR_SLIP = "02"; // 赤伝
// 削除
export const GC_D2017_VALID = "0"; // 有効
export const GC_D2017_DELETED = "1"; // 削除済
// ファイル転送タイプ
export const GC_D2019_ASCII = "1"; // アスキー
export const GC_D2019_BINARY = "2"; // バイナリー
// ファイル作成タイプ
export const GC_D2020_OVERWRITE = "1"; // 上書き
export const GC_D2020_APPEND = "2"; // 追加
// 接続タイプ
export const GC_D2021_ACTIVE = "1"; // アクティブ
export const GC_D2021_PASSIVE = "2"; // パシッブ
// 方向タイプ
export const GC_D2022_SEND = "1"; // 送信
export const GC_D2022_RECEIVE = "2"; // 受信
// プロセスタイプ（送信後）
export const GC_D2023_RENAME = "1"; // リネーム
export const GC_D2023_END_FILE = "2"; // エンドファイル 
// プロセスタイプ（受信後）
export const GC_D2024_DELETE_FILE = "1"; // 削除する
export const GC_D2024_KEEP_FILE = "2"; // 削除しない
// エラー分類 (ケース品)
export const GC_D2026_NO_ERROR = "0"; // エラーなし
export const GC_D2026_DEPT_MISMATCH = "1"; // ケースと単品の登録分類違い
export const GC_D2026_MAKER_MISMATCH = "2"; // ケースと単品の登録メーカー違い
// 曜日区分
export const GC_D2028_MONDAY = "01"; // 月曜
export const GC_D2028_TUESDAY = "02"; // 火曜
export const GC_D2028_WEDNESDAY = "03"; // 水曜
export const GC_D2028_THURSDAY = "04"; // 木曜
export const GC_D2028_FRIDAY = "05"; // 金曜
export const GC_D2028_SATURDAY = "06"; // 土曜
export const GC_D2028_SUNDAY = "07"; // 日曜
// 配信タイプ
export const GC_D2031_SCHEDULED = "01"; // 定時
export const GC_D2031_DAILY = "02"; // 日次
export const GC_D2031_MONTHLY = "03"; // 月次
export const GC_D2031_AD_HOC = "04"; // 随時
// 発注変換フラグ
export const GC_D2034_UNSET = "1"; // 未設定
export const GC_D2034_PIECE_TO_CASE = "2"; // バラ→ケース
export const GC_D2034_CASE_TO_PIECE = "3"; // ケース→バラ
// 承認階層
export const GC_D2040_SINGLE_APPROVE = "01"; // 1段階承認
// バッチ処理ステータス
export const GC_D2041_RUNNING = "0"; // 実行中
export const GC_D2041_COMPLETED = "1"; // 正常終了
export const GC_D2041_WARNING = "2"; // 警告
export const GC_D2041_FORCED_END = "8"; // 強制終了
export const GC_D2041_ERROR_END = "9"; // 異常終了
// バッチ処理起動元
export const GC_D2042_JOB = "01"; // JOB
export const GC_D2042_WEB = "02"; // WEB
// 活動中フラグ
export const GC_D2043_ACTIVE = "0"; // 活動中
export const GC_D2043_INACTIVE = "1"; // 停止中
// ＯＳタイプ
export const GC_D2044_LINUX = "01"; // リナックス
export const GC_D2044_WINDOWS = "02"; // ウィンドウズ
// 金額手数料区分
export const GC_D2047_EDI_ORDER_COST = "1"; // EDI発注原価
export const GC_D2047_EDI_PURCHASE_COST = "2"; // EDI仕入原価
export const GC_D2047_EDI_MANUAL_COST = "3"; // EDI+手書仕入原価
// 集計区分
export const GC_D2048_DATA_VOLUME = "1"; // データ量
export const GC_D2048_AMOUNT = "2"; // 金額
// 初回発注入力
export const GC_D2049_NO_INITIAL = "01"; // しない
export const GC_D2049_INITIAL_ORDER = "02"; // する
// 発注停止（店）
export const D2050_NORMAL = "01"; // 通常
export const D2050_STOP = "02"; // 停止
export const D2050_REVALUE = "03"; // 評価替
// 商品変更区分
export const GC_D2051_NEW_ENTRY = "01"; // 新規商品登録
export const GC_D2051_CHANGE_ENTRY = "02"; // 既存商品変更
export const GC_D2051_DELETE_ENTRY = "03"; // 既存商品削除
// 更新操作区分
export const GC_D2052_NORMAL = "01"; // 通常
export const GC_D2052_RESERVE = "02"; // 予約
export const GC_D2052_CSV_IMPORT = "03"; // CSV取込
export const GC_D2052_POS_SEND_AUTO = "04"; // POS送信区分自動更新
export const GC_D2052_POS_COST_AUTO = "05"; // POS原価自動更新
export const GC_D2052_EXTERNAL_IF = "06"; // 外部I/F
// 集計単位
export const GC_D2053_BY_PAYEE_STORE = "01"; // 支払先店舗別
export const GC_D2053_BY_PAYEE = "02"; // 支払先別
// 商品販売区分
export const GC_D2054_SALES_REGULAR = "01"; // 定番
export const GC_D2054_SALES_PROMO = "03"; // 企画
// 買掛締区分
export const GC_D2062_TEMP_CLOSE = "1"; // 仮締
export const GC_D2062_FINAL_CLOSE = "2"; // 本締
// 仕入取引伝票区分
export const GC_D2063_PURCHASE = "01"; // 仕入
export const GC_D2063_RETURN_ITEM = "02"; // 返品
export const GC_D2063_DISCOUNT = "04"; // 値引
// 請求書取込状況
export const GC_D2065_NOT_IMPORTED = "0"; // 未取込 
export const GC_D2065_CSV_IMPORTED = "1"; // CSVインポート済
export const GC_D2065_MANUAL_ENTRY = "2"; // 手入力
// 請求照合状況
export const GC_D2066_MATCHED = "0"; // 照合済み
export const GC_D2066_UNMATCHED = "1"; // 未照合有
export const GC_D2066_DIFF_FOUND = "2"; // 差異有
export const GC_D2066_FORCED_MATCH = "3"; // 強制照合済
// イベント種別
export const GC_D2068_LOGIN = "01"; // ログイン
export const GC_D2068_LOGOUT = "02"; // ログアウト
export const GC_D2068_SCREEN_CHANGE = "03"; // 画面遷移
export const GC_D2068_FILE_DOWNLOAD = "04"; // ファイルダウンロード
// デバイス種別
export const GC_D2069_PC = "01"; // PC
export const GC_D2069_TABLET = "02"; // タブレット
export const GC_D2069_MOBILE = "03"; // モバイル
export const GC_D2069_OTHERS = "04"; // その他
// 支払保留フラグ
export const GC_D2070_PAYMENT_TARGET = "0"; // 支払対象
export const GC_D2070_PAYMENT_HOLD = "1"; // 支払保留
export const GC_D2070_HOLD_RELEASE = "2"; // 保留解除
// 優先方式
export const GC_D2073_QTY_COMPARE = "1"; // 数量比較
export const GC_D2073_HQ_PRIORITY = "2"; // 本部優先
export const GC_D2073_INDIV_ORDER = "3"; // 個別発注
// 便/回数
export const GC_D2074_NOON_ORDER = "1"; // 昼発注
export const GC_D2074_EVENING_ORDER = "2"; // 夕方発注
// 商品ステータス
export const GC_D2076_NORMAL = "1"; // 正常
export const GC_D2076_WARNING = "2"; // ワーニング
export const GC_D2076_ERROR = "9"; // エラー
// 欠品責任区分
export const GC_D2078_PARTNER_FAULT = "01"; // パートナー責任
export const GC_D2078_RETAIL_FAULT = "02"; // 小売責任
// 照合結果
export const GC_D2081_MATCHED = "00"; // 照合一致
export const GC_D2081_INVOICE_LESS = "01"; // 請求＜仕入
export const GC_D2081_INVOICE_MORE = "02"; // 請求＞仕入
export const GC_D2081_DATE_MISMATCH = "03"; // 検収日不一致
export const GC_D2081_INVOICE_ONLY = "04"; // 請求のみ
export const GC_D2081_PURCHASE_ONLY = "05"; // 仕入のみ
export const GC_D2081_PAST_PURCHASE = "06"; // 過去仕入分
export const GC_D2081_PAST_INVOICE = "07"; // 過去請求分
export const GC_D2081_DUE_DATE_MISMATCH = "08"; // 先限日不一致
// 申請状態(店間移動)
export const GC_D2083_OUT_REQUESTING = "0"; // 出庫申請中
export const GC_D2083_OUT_APPROVED = "1"; // 出庫承認済
export const GC_D2083_IN_APPROVED = "2"; // 入庫承認済
export const GC_D2083_OUT_REJECTED = "3"; // 出庫申請却下
// 店舗承認区分
export const GC_D2084_STORE_NOT_APPROVED = "00"; // 店舗未承認
export const GC_D2084_STORE_APPROVED = "01"; // 店舗承認済
export const GC_D2084_HQ_PROCESSING = "02"; // 本部対応中
export const GC_D2084_HQ_APPROVED = "03"; // 本部承認済
export const GC_D2084_SLIP_CREATED = "04"; // 伝票作成済
export const GC_D2084_ORDER_ERROR = "11"; // 発注エラー
export const GC_D2084_STORE_REJECTED = "98"; // 店舗却下
export const GC_D2084_HQ_REJECTED = "99"; // 本部却下
// 緊急発注区分
export const GC_D2085_NORMAL_ORDER = "1"; // 通常発注
export const GC_D2085_URGENT_ORDER = "2"; // 緊急発注
// 廃棄・振替伝票区分
export const GC_D2086_DISCARD = "01"; // 廃棄
export const GC_D2086_LOSS = "02"; // ロス
export const GC_D2086_EXP_TRANSFER = "03"; // 経費振替
export const GC_D2086_THEFT = "04"; // 盗難
// 申請状態(廃棄)
export const GC_D2087_REQUESTING = "0"; // 申請中
export const GC_D2087_APPROVED = "1"; // 承認済
export const GC_D2087_REJECTED = "2"; // 申請却下
